function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  transform: "translate(-1029.936 -636.441)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_332",
  "data-name": "Rectangle 332",
  width: 38.885,
  height: 27.383,
  rx: 5,
  transform: "translate(1029.936 636.441)",
  fill: "#36495d"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_333",
  "data-name": "Rectangle 333",
  width: 6.533,
  height: 11.74,
  transform: "translate(1046.112 644.263)",
  fill: "#f16522"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_177",
  "data-name": "Path 177",
  d: "M1100.227,695.54a7.454,7.454,0,0,1,2.852-5.87,7.466,7.466,0,1,0,0,11.739,7.454,7.454,0,0,1-2.852-5.87",
  transform: "translate(-53.7 -45.408)",
  fill: "#e41b24"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_178",
  "data-name": "Path 178",
  d: "M1203.279,695.543a7.465,7.465,0,0,1-12.079,5.869,7.468,7.468,0,0,0,0-11.74,7.466,7.466,0,0,1,12.079,5.87m-.712,4.627v-.24h.1v-.048h-.247v.048h.1v.24Zm.479,0v-.289h-.076l-.087.2-.087-.2h-.076v.289h.053v-.219l.082.189h.056l.082-.189v.219Z",
  transform: "translate(-141.821 -45.41)",
  fill: "#f89e1c"
}));

function SvgIcMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.885,
    height: 27.383,
    viewBox: "0 0 38.885 27.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaster);
export default ForwardRef;